<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Promotions
      </h1>
      <ol class="breadcrumb">
        <li>
          <a @click="$router.push({ name: 'dashboard' })">
            <i class="fa fa-dashboard"></i> Dashboard
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'promo-index' })">
            <i class="fa fa-gift"></i> Promotions
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'promo-config-index' })">
            <i class="fa fa-credit-card"></i> Payments
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <div class="box-title">
            <h3>{{ title }}</h3>
          </div>
        </div>

        <div class="box-body" style="overflow: unset;">
          <div class="row">
            <div class="col-12 col-md-12 col-lg-10">

              <div class="form-horizontal">
                <div class="form-group">
                  <label for="name"
                    class="col-sm-3 control-label">
                    Promo Name <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <input
                      v-model="form.name"
                      type="text"
                      id="promo-name"
                      name="promo-name"
                      class="form-control"
                      placeholder="Promo name">
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-description"
                    class="col-sm-3 control-label">
                    Payment Description <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <textarea
                      v-model="form.description"
                      id="promo-description"
                      name="promo-description"
                      class="form-control"
                      row="6"
                      placeholder="Promo description">
                    </textarea>
                  </div>
                </div>

                <div class="form-group">
                  <label for="name"
                    class="col-sm-3 control-label">
                    Promo Type <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <v-select multiple
                      id="type"
                      name="type"
                      v-model="form.type"
                      :options="types">
                    </v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="days"
                    class="col-sm-3 control-label">
                    Days <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <span class="btn btn-default btn-xs"
                      @click="toggleAllDays">
                      All Days
                    </span>

                    <template v-for="item in days">
                      <label :key="item.value" class="checkbox-inline" :for="item.value">
                        <input type="checkbox"
                          :id="item.value"
                          :value="item.value"
                          v-model="form.days">
                          {{ item.label }}
                      </label>
                    </template>
                  </div>
                </div>

                <div class="form-group">
                  <label for="methods"
                    class="col-sm-3 control-label">
                    Payment Methods <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <v-select multiple
                      id="methods"
                      name="methods"
                      v-model="form.payment_method"
                      :options="payments">
                    </v-select>
                  </div>
                </div>

                <!-- Hide dulu, karena fitur installment belum ada -->
                <!-- <div class="form-group">
                  <label for="installment"
                    class="col-sm-3 control-label">
                    Installment
                  </label>

                  <div class="col-sm-9">
                    <v-select multiple
                      id="installment"
                      name="installment"
                      v-model="form.installment_tenor"
                      :options="installments">
                    </v-select>
                  </div>
                </div> -->

                <div class="form-group">
                  <label for="name"
                    class="col-sm-3 control-label">
                    Status <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <v-select
                      v-model="form.is_enabled"
                      :options="statuses">
                    </v-select>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="box-footer">
          <button class="btn btn-info pull-right"
            @click="submit">
            <template v-if="isCreate">Create</template>
            <template v-else>Update</template>
          </button>

          <a class="btn btn-default"
            @click.prevent="cancel">
            Cancel
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import { API_GATEWAY, X_API_KEY, X_SECRET_KEY } from '@/config';
import API_BASEURL from '@/config';
import Common from '@/mixins/Common';

export default {
  name: 'PromoConfigForm',

  mixins: [Common],

  data() {
    return {
      title: 'Create Promo Payments',

      error: null,

      form: {
        id: null,
        name: null,
        description: null,
        type: [],
        days: [],
        payment_method: [],
        installment_tenor: [],
        is_enabled: {
          label: 'Active',
          value: 1,
        },
      },

      statuses: [
        {
          label: 'Active',
          value: 1,
        },
        {
          label: 'Inactive',
          value: 0,
        },
      ],

      installments: [
        {
          label: '3 Months',
          value: 3,
        },
        {
          label: '6 Months',
          value: 6,
        },
        {
          label: '12 Months',
          value: 12,
        },
      ],

      types: [
        {
          label: 'Promo Code',
          value: 'promocode',
        },
        // Hide dulu karena installment belum ada
        // {
        //   label: 'Installment',
        //   value: 'installment',
        // },
      ],

      days: [
        {
          label: 'Mon',
          value: 1,
        },
        {
          label: 'Tue',
          value: 2,
        },
        {
          label: 'Wed',
          value: 3,
        },
        {
          label: 'Thu',
          value: 4,
        },
        {
          label: 'Fri',
          value: 5,
        },
        {
          label: 'Sat',
          value: 6,
        },
        {
          label: 'Sun',
          value: 7,
        },
      ],

      payments: [],
    };
  },

  props: {
    isCreate: {
      type: Boolean,
      required: false,
    },
  },

  methods: {
    getPaymentMethods() {
      return new Promise((resolve, reject) => {
        const config = {
          baseURL: API_BASEURL,
          params: {
            page: 1,
            perpage: 100,
          },
        };

        this.axios.get('/payments/v2/payment-method', config)
          .then((response) => {
            const { data } = response.data;
            data.forEach((item) => {
              this.payments.push({
                label: item.name,
                value: item.id,
              });
            });
            resolve();
          })
          .catch((error) => {
            console.log(error);
            reject(error);
            this.$swal({
              title: 'Failed',
              text: 'Failed to fetch available payment methods',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again',
            }).then((result) => {
              if (result.value) {
                this.getPaymentMethods();
              }
            });
          });
      });
    },

    fetch() {
      this.axios.get(`/promoconfigs/${this.$route.params.id}`)
        .then((response) => {
          const { data } = response.data;
          const typeData = [];
          if (data.type !== null && data.type.length > 0) {
            data.type.forEach((selected) => {
              this.types.forEach((item) => {
                if (item.value === selected) {
                  typeData.push(item);
                }
              });
            });
          }

          const paymentMethodData = [];
          if (data.payment_method !== null && data.payment_method.length > 0) {
            data.payment_method.forEach((selected) => {
              this.payments.forEach((item) => {
                if (item.value === selected.id) {
                  paymentMethodData.push(item);
                }
              });
            });
          }

          const installmentTenorData = [];
          if (data.installment_tenor !== null && data.installment_tenor.length > 0) {
            data.installment_tenor.forEach((selected) => {
              this.installments.forEach((item) => {
                if (item.value === selected) {
                  installmentTenorData.push(item);
                }
              });
            });
          }

          let enabled = {};
          this.statuses.forEach((item) => {
            if (item.value === data.is_enabled) {
              enabled = item;
            }
          });

          this.form.id = data.id;
          this.form.name = data.name;
          this.form.description = data.description;
          this.form.days = data.days;
          this.form.type = typeData;
          this.form.payment_method = paymentMethodData;
          this.form.installment_tenor = installmentTenorData;
          this.form.is_enabled = enabled;
        })
        .catch((error) => {
          if (error.response) {
            this.errors = error.response.data.errors;
          }

          if (error) {
            this.$swal({
              title: 'Failed',
              text: 'Failed to fetch promo config detail',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again',
            }).then((result) => {
              if (result.value) {
                this.fetch();
              }
            });
          }
        });
    },

    toggleAllDays() {
      if (this.form.days.length < 1) {
        this.form.days = [1, 2, 3, 4, 5, 6, 7];
      } else {
        this.form.days = [];
      }
    },

    prepareValues(arr) {
      if (!arr) return [];

      // Make sure object is array
      const isItArray = Array.isArray(arr);
      if (!isItArray) {
        arr = [arr];
      }

      // Return only value
      const values = [];
      arr.forEach((item) => {
        values.push(item.value);
      });

      return values;
    },

    validate() {
      if (!this.form.name) {
        this.$swal('Promo name required', 'Please fill promo name to continue', 'warning');
        return false;
      }

      if (!this.form.description) {
        this.$swal('Promo description required', 'Please fill promo description to continue', 'warning');
        return false;
      }

      if (this.form.type.length > 1) {
        this.$swal('Promo Type exceeded', 'Please select only one promo type', 'warning');
        return false;
      }

      if (!this.form.type || this.form.type.length < 1) {
        this.$swal('Promo Type required', 'Please select promo type', 'warning');
        return false;
      }

      if (!this.form.days || this.form.days.length < 1) {
        this.$swal('Promo days required', 'Please select active promo days', 'warning');
        return false;
      }

      if (!this.form.payment_method || this.form.payment_method.length < 1) {
        this.$swal('Promo payment method required', 'Please select promo payment method', 'warning');
        return false;
      }

      if (!this.form.is_enabled || this.form.is_enabled.length < 1) {
        this.$swal('Promo payment status required', 'Please select promo payment status', 'warning');
        return false;
      }

      return true;
    },

    submit() {
      const result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },

    create() {
      const typeData = this.prepareValues(this.form.type);
      const paymentData = this.prepareValues(this.form.payment_method);
      const installmentData = this.prepareValues(this.form.installment_tenor);

      const data = {
        name: this.form.name,
        description: this.form.description,
        days: JSON.stringify(this.form.days),
        type: JSON.stringify(typeData),
        payment_method: JSON.stringify(paymentData),
        installment_tenor: JSON.stringify(installmentData),
        is_enabled: 1,
      };

      return this.axios.post('/promoconfigs', this.stringify(data))
        .then(() => {
          this.$swal({
            title: 'created',
            text: `${this.form.name} has been created.`,
            type: 'success',
            timer: 3000,
          });

          this.$router.push({ name: 'promo-config-index' });
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data.errors;

            this.$swal({
              title: 'Create Failed!',
              text: 'Failed to create new Promo Config',
              type: 'warning',
              timer: 5000,
            });
          }
        });
    },

    update() {
      const typeData = this.prepareValues(this.form.type);
      const paymentData = this.prepareValues(this.form.payment_method);
      const installmentData = this.prepareValues(this.form.installment_tenor);

      const data = {
        name: this.form.name,
        description: this.form.description,
        days: JSON.stringify(this.form.days),
        type: JSON.stringify(typeData),
        payment_method: JSON.stringify(paymentData),
        installment_tenor: JSON.stringify(installmentData),
        is_enabled: this.form.is_enabled.value.toString(),
      };

      this.axios.put(`/promoconfigs/${this.form.id}`, this.stringify(data))
        .then(() => {
          this.$swal({
            title: 'Updated',
            text: `${this.form.name} has been updated.`,
            type: 'success',
            timer: 3000,
          });
          this.$router.push({ name: 'promo-config-index' });
        })
        .catch((error) => {
          if (error.response) {
            this.$swal({
              title: 'Failed',
              text: `Failed to update ${this.form.name}.`,
              type: 'warning',
              timer: 5000,
            });
            this.error = error.response.data.errors;
          }
        });
    },

    cancel() {
      this.$router.go(-1);
    },

    async init() {
      await this.getPaymentMethods();
    
      if (!this.isCreate) {
        this.title = 'Edit Promo Config';
        this.fetch();
      }
    },
  },

  mounted() {
    this.init();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/promo/config/Form.vue